export default __webpack_public_path__ + "static/media/rae-logo.7084be1f.png";